import React from 'react'
import { Drawer, Card, Button, Form, Row, Col } from 'antd'
import { formItemLayout, chooseEmailModalFxn, RemarksList } from '../../../../components/_utils/appUtils'
import { useDispatch } from 'react-redux'
import GetEachFormFields from '../../../../components/_utils/appFormUtils'
// import { SendAbstractComments } from '../actions'
import _ from 'lodash'

const AddAbstractRemarks = (props) => {
  let { visible, onClose, abstract, reviewerId, form: { getFieldDecorator, getFieldValue, setFieldsValue } } = props
  const dispatch = useDispatch()

  const getRemarkList = () => {
    return _.filter(RemarksList, (item) => item !== 'Direct Article Received')
  }

  const inputSchema = {
    fields: [
      {
        label: 'Remarks',
        key: 'remarks',
        required: true,
        showSearch: true,
        options: getRemarkList(),
        keyAccessor: x => x,
        valueAccessor: x => x,
        placeholder: 'Remarks',
        type: 'select',
        onChange: (val) => setFieldsValue({ remarks: val }),
        span: 24
      },
      {
        label: 'Comments',
        key: 'comments',
        type: 'textArea',
        hidden: getFieldValue('remarks') !== 'Other text box',
        required: getFieldValue('remarks') === 'Other text box',
        placeholder: 'Comments',
        span: 24
      }
    ]
  }

  const handleSubmit = e => {
    const { form } = props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        valData.abstractId = abstract._id // Changed from articleId
        valData.reviewerId = reviewerId

        chooseEmailModalFxn({
          callback: async (email) => {
            valData.fromEmail = email
            // Dispatch the abstract-specific action
            // let { success } = await dispatch(SendAbstractComments(valData))
            // if (success) {
            //   dispatch({ type: 'START_LOAD_ABSTRACT' }) // Ensure this matches your abstract reducer logic
            //   onClose()
            // }
          }
        })
      }
    })
  }

  return (
    <Drawer
      title={'Add Remarks | Abstract'}
      width={'65%'}
      visible={visible}
      placement='right'
      onClose={onClose}>
      <Card>
        <Form onSubmit={handleSubmit} hideRequiredMark className={'inputForm'}>
          <Row gutter={16}>
            {inputSchema.fields.map((item, key) => (
              <Col span={item.span || 8} key={key}>
                <GetEachFormFields
                  getFieldDecorator={getFieldDecorator}
                  item={item}
                  formItemLayout={formItemLayout}
                />
              </Col>
            ))}
            <Col span={24}>
              <Form.Item style={{ marginTop: 40 }}>
                <Button type='primary' htmlType='submit'>Submit</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Drawer>
  )
}

export default Form.create()(AddAbstractRemarks)
